export const categories = [
  {
    slug: 'download-tutorial',
    name: '下载教程',
    description: '安卓与iOS设备下载东升大舞台App的详细步骤指南',
    icon: 'ri-download-cloud-2-line',
  },
  {
    slug: 'login-register',
    name: '登录注册',
    description: '东升大舞台App账号注册与登录的完整流程说明',
    icon: 'ri-user-add-line',
  },
  {
    slug: 'user-guide',
    name: '使用指南',
    description: '东升大舞台App核心功能使用教程与操作技巧',
    icon: 'ri-guide-line',
  },
  {
    slug: 'faq',
    name: '常见问题',
    description: '用户最常遇到的东升大舞台相关问题与官方解答',
    icon: 'ri-question-answer-line',
  },
  {
    slug: 'latest-news',
    name: '最新动态',
    description: '东升大舞台App版本更新、活动公告与行业资讯',
    icon: 'ri-newspaper-line',
  },
];